import { FC, ReactNode, useState } from 'react';
import { MotifHeader, MotifHeaderLogo, MotifIcon } from '@ey-xd/motif-react';
import { defaultLogo } from '@ey-xd/motif-react/assets/images';
import { MotifAvatar } from '@ey-xd/motif-react';
import { MotifDropdown } from '@ey-xd/motif-react';
import { MotifDropdownItem } from '@ey-xd/motif-react';

import { Home } from 'common/components';
import { APP_MENU_OPTIONS, MAIN_ROUTES, msalInstance } from 'common/config';
import { AppAction } from 'common/enums';

import { ICON_COLLECTION } from 'assets/media/icons';

import './Header.scss';

type CustomHeaderProps = {
    appHeaderName?: string;
    avatar?: string;
    userName?: string;
};

const Header: FC<CustomHeaderProps> = ({ appHeaderName, avatar, userName }) => {
    const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);

    const handleMenuToggle = () => {
        setIsMenuVisible(!isMenuVisible);
    };

    const onAction = (option: any) => () => {
        switch (option.label) {
            case AppAction.Logout: {
                msalInstance.logoutRedirect();
            }
        }
    };

    const getDropDownItem = (option: any, index: number): ReactNode => (
        <MotifDropdownItem
            className="app-header-menu-item"
            action={option.label}
            key={index}
            disabled={option.disable}
            onClick={onAction(option)}>
            <MotifIcon src={option.iconSrc} />
            {option.label}
        </MotifDropdownItem>
    );

    const isHomePage =
        location.pathname === MAIN_ROUTES.DEFAULT || location.pathname === MAIN_ROUTES.HOME;

    return (
        <>
            <div className="app-header-container">
                <MotifHeader
                    className="app-header"
                    logo={
                        <MotifHeaderLogo>
                            <a href="/">
                                <MotifIcon src={defaultLogo} aria-hidden="true" />
                            </a>
                        </MotifHeaderLogo>
                    }
                    appHeaderName={appHeaderName}
                />
                <div className="app-header-container-right">
                    <Home isSelected={isHomePage} />
                    <MotifAvatar
                        className="app-header-avatar"
                        src={avatar}
                        userName={userName ? userName.trim() : ''}
                        status=""
                    />
                    {userName && <span className="app-header-username">{userName}</span>}
                    <MotifDropdown
                        className="app-header-menu"
                        open={isMenuVisible}
                        trigger={
                            isMenuVisible ? (
                                <MotifIcon
                                    className="app-header-menu-icon"
                                    src={ICON_COLLECTION.IC_ExpandLess}
                                    onClick={handleMenuToggle}
                                />
                            ) : (
                                <MotifIcon
                                    className="app-header-menu-icon"
                                    src={ICON_COLLECTION.IC_ExpandMore}
                                    onClick={handleMenuToggle}
                                />
                            )
                        }>
                        {APP_MENU_OPTIONS.map((opt: any, index: number) =>
                            getDropDownItem(opt, index)
                        )}
                    </MotifDropdown>
                </div>
            </div>
        </>
    );
};

export default Header;
